import { useToast, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import { useParams } from "react-router-dom";
import { QuoteApi } from "../api/QuoteApi";
import QuoteTableContainer from "../components/QuoteTableContainer";
import { Quote } from "../lib/models/quote.model";
import { QuoteUtils } from "../lib/quote-utils";

function UserByIdQuotesView() {
  const toast = useToast();
  const toastVariant = useColorModeValue("subtle", "solid");
  const { id } = useParams<{ id: string }>();

  const [quotes, setQuotes] = React.useState<Quote[]>([]);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [ownerName, setOwnerName] = React.useState<string>();
  const fetchQuotes = React.useCallback(() => {
    setLoading(true);

    QuoteApi.getQuotesById(id)
      .then((res) => {
        const activeQuotes = res.data.map((x) => {
          x.quoteTypeLabel = QuoteUtils.PrettyPrintQuoteType(x.quoteType);
          x.createdBy = `${x.firstname} ${x.lastname}`;
          return x;
        });

        setQuotes(activeQuotes);
        setOwnerName(activeQuotes[0].createdBy);
      })
      .catch((err) => {
        toast({
          title: "Unable to Load Quotes",
          description: "An error has occurred when attempting to fetch quotes",
          status: "error",
          variant: toastVariant,
          isClosable: true,
          position: "top-right",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [setQuotes, id, toast, toastVariant]);

  React.useEffect(() => {
    fetchQuotes();
  }, [fetchQuotes]);

  return (
    <QuoteTableContainer
      refetchQuotes={fetchQuotes}
      loading={loading}
      title={`Quotes for ${ownerName}`}
      quotes={quotes}
      emptyTableLabel={`There are no quotes for ${ownerName}.`}
      showAddQuoteMenu={false}
    />
  );
}

export default UserByIdQuotesView;
